module.exports = __webpack_public_path__ + "static/media/124.56781f0f.png";